import type { Graph, Thing, WithContext } from "schema-dts";

export type StructuredDataSchema = Thing | WithContext<Thing> | Graph;

export function getStructuredDataScript(schema: StructuredDataSchema): string {
	return `<script type="application/ld+json">${JSON.stringify(schema)}</script>`;
}
